import { Component, OnInit } from '@angular/core';
import { TableHeaderService } from './table-header.service';

@Component({
  selector: 'tog-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
  providers: [TableHeaderService]
})
export class TableHeaderComponent implements OnInit {

  constructor(private _ths: TableHeaderService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/table-header/table-header.component.ts